import React from 'react';
import Link from 'redux-first-router-link';
import styled from 'styled-components';
import { connect } from 'react-redux';

import { getUriLangCode } from './../reducers/selectors';

const InternalLink = ({ to, language, ...props }) => {
    const StyledLink = styled(Link)`
        &.stolo-internal-link {
            text-decoration: none;
            color: ${props => props.theme.palette.secondary[500]};
            border-bottom: 1px solid transparent;
            &:visited {
              border-bottom: 1px solid transparent;
              color: ${props => props.theme.palette.secondary[700]};
            }
            &:focus,
            &:hover {
              border-bottom: 1px dashed  ${props => props.theme.palette.secondary[700]};
            }
            &:active {
              border-bottom: 1px solid ${props => props.theme.palette.secondary[500]};
              color: ${props => props.theme.palette.secondary[500]};
            }
            
           
        }
    `;

    // Assignes to.payload as last object. So the language parameter of the
    // route action could be overwriten by a provided language, though that
    // should rarely happen.
    const payload = Object.assign(
        {},
        { language: language || null },
        (
            to ? to.payload || {} : {}
        ),
    );
    const target = typeof (to) === 'string' ? to : Object.assign({}, to, { payload });

    return (
        <StyledLink className='stolo-internal-link' to={target} {...props} />
    );
};

const makeMapStateToProps = (initialState, initialOwnProps) => {
    const language = getUriLangCode(initialState);
    const to = initialOwnProps.to;
    const mapStateToProps = (state, ownProps) => (
        {
            to,
            language,
            ...ownProps,
        }
    );
    return mapStateToProps;
};

export default connect(makeMapStateToProps)(InternalLink);



// WEBPACK FOOTER //
// ./src/components/InternalLink.js